import React, { Component, createRef, useRef } from 'react';
import { createPopper } from '@popperjs/core';
import FocusTrap from 'focus-trap-react';
import { Link } from 'react-router-dom';

import '../../css/Popup.scss';
import Portal from '../Portal/Portal';
import CameraIcon from '../CameraIcon/CameraIcon';


class Popup extends Component<{placement, strategy, modifiers}, {isOpen}> {
    triggerRef = createRef<HTMLAnchorElement>();
    popupRef = createRef<HTMLDivElement>();
    popper: any;

    state = {
        isOpen: false,
    };

    public constructor(props) {
        super(props);

        this.togglePopup = this.togglePopup.bind(this);
    }

    public componentDidMount(): void {
        if (!this.state.isOpen) this.togglePopup();

        this.popper = createPopper(this.triggerRef.current as Element, this.popupRef.current as HTMLElement, {
            placement: this.props.placement || 'bottom-start',
            strategy: this.props.strategy || 'fixed',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
                ...(this.props.modifiers || []),
            ],
        });
    }

    public componentWillUnmount(): void {
        this.popper.destroy();
    }

    private togglePopup(): void {
        this.setState(
            (state) => {
                return {
                    isOpen: !state.isOpen,
                };
            },
            () => {
                this.popper.forceUpdate();
            },
        );
    }

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <Link to="/caticlick/dashboard" className="camera-icon-container trigger" ref={this.triggerRef}>
                    <CameraIcon />
                </Link>

                <Portal>
                    <div className="popup__container" ref={this.popupRef}>
                        {this.state.isOpen && (
                            <React.Fragment>
                                <FocusTrap
                                    focusTrapOptions={{
                                        onDeactivate: this.togglePopup,
                                        clickOutsideDeactivates: true,
                                    }}
                                >
                                    <div className="popup">
                                        <div tabIndex={0}>
                                            Click the Camera <br /> to Take New Photo!
                                        </div>
                                    </div>
                                </FocusTrap>
                            </React.Fragment>
                        )}
                    </div>
                </Portal>
            </React.Fragment>
        );
    }
}

export default Popup;
